import { Component, forwardRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { provideNgxMask } from 'ngx-mask';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrl: './textarea.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TextareaComponent),
    },
    provideNgxMask({
      patterns: {
        K: { pattern: new RegExp("\[\u0400-\u052F\u2DE0-\u2DFF\uA640-\uA69F'a-zA-Z\]") },
        '0': { pattern: new RegExp('\[0-9\]') },
      },
    }),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TextareaComponent implements ControlValueAccessor {
  @Input() formControl!: FormControl<string | null>;
  @Input() maxLength: number | null = null;
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;

  onChangeCallback = (_: any) => {};
  onTouchedCallback = (_: any) => {};

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  writeValue(value: string) {
    if (value !== this.formControl.value) {
      this.formControl.setValue(value);
    }
  }

  onChange(event: any): void {
    this.onChangeCallback(event.target.value);
  }
}
